<template>
  <div class="bbp-list-requests-main-header">
    <h2 class="bbp-title-page">
      List of Requests
    </h2>
    <ListOfRequestsEarnings :totalAmount="totalAmount" />
  </div>
</template>

<script>
import ListOfRequestsEarnings from '@/components/Requests/ListOfRequests/ListOfRequestsEarnings'

export default {
  name: 'ListOfRequestsHeader',
  components: {
    ListOfRequestsEarnings
  },
  props: {
    totalAmount: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>

  .bbp-list-requests-main-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/Requests/ListOfRequests/ListOfRequestsHeader.vue